import React from 'react';
import { string, func, object, oneOf } from 'prop-types';
import classnames from 'classnames/bind';
import { renderLinks } from '../../common';

import Illustration from 'foundations/Illustrations/Illustration';

import styles from './HotspotC.css';
import textStyles from './text-styles.css';

const cx = classnames.bind(styles);
const cxTxt = classnames.bind(textStyles);

const HotspotC = ({
  highlighted,
  title,
  colorScheme,
  description,
  link,
  onClick,
  withIllustration,
  imageUrl
}) => {
  
  const links = [
    {
      colorScheme,
      onClick,
      class: styles.link,
      text: link,
      icon: { direction: 'right', name: 'link-arrow-right', type: '30' },
      size: 'xl',
      minWidth: 1025
    },
    {
      colorScheme,
      onClick,
      class: styles.link,
      text: link,
      icon: { direction: 'right', name: 'arrow-right', type: '20' },
      size: 'l',
      minWidth: 769,
      maxWidth: 1024
    },
    {
      colorScheme,
      onClick,
      class: styles.link,
      text: link,
      icon: { direction: 'right', name: 'arrow-right', type: '20' },
      size: 'm',
      minWidth: 321,
      maxWidth: 768
    },
    {
      colorScheme,
      onClick,
      class: styles.link,
      text: link,
      icon: { direction: 'right', name: 'link-arrow-right-17', type: 'other' },
      size: 's',
      maxWidth: 320
    }
  ];

  return (
  <div className={classnames(styles.wrapper, colorScheme)}>
    <div className={styles.container}>
      <h1 className={classnames(cxTxt('title', { 'v2': !description }), cx('title', { 'v2': !description }))}>
        {highlighted && <span className={styles.highlight}>{highlighted}</span>} {title}
      </h1>

      {
        description &&
          <p className={classnames(textStyles.description, styles.description)}>{description}</p>
      }
      
      { renderLinks(links) }

      {
        withIllustration &&
          <Illustration
            name={withIllustration.name}
            size={withIllustration.size}
            customClasses={styles.illustration}
          />
      }

      { imageUrl && <div className={styles.image} style={{ backgroundImage: `url(${imageUrl})` }} /> }
    </div>
  </div>
  );
};

HotspotC.propTypes = {
  highlighted: string,
  title: string.isRequired,
  colorScheme: oneOf([
    'lb01',
    'lb02',
    'lb03',
    'lb04',
    'lb05',
    'lb06',
    'lb07',
    'lb08',
    'db01',
    'db02',
    'db03',
    'db04',
  ]),
  description: string,
  link: string.isRequired,
  onClick: func,
  withIllustration: object,
  imageUrl: string,
};

HotspotC.defaultProps = {
  colorScheme: 'lb01'
};

HotspotC.displayName = 'HotspotC';

export default HotspotC;


// WEBPACK FOOTER //
// ./src/uis/components/Hotspots/Landing/HotspotC/HotspotC.js